<template>
  <div
    v-if="visible"
    class="push-prompt-overlay"
    @click.self="$emit('dismiss')"
  >
    <div class="push-prompt" role="dialog" :aria-labelledby="titleId">
      <div class="push-prompt-icon" aria-hidden="true">
        <i class="pi pi-bell" />
      </div>
      <h2 :id="titleId" class="push-prompt-title">
        {{ $t("push_prompt_title") }}
      </h2>
      <p class="push-prompt-msg">
        {{ $t("push_prompt_message") }}
      </p>
      <div class="push-prompt-actions">
        <Button
          class="w-full"
          :label="$t('push_prompt_activate')"
          :loading="activating"
          :disabled="activating"
          @click="$emit('activate')"
        />
        <Button
          class="p-button-secondary p-button-outlined w-full"
          :label="$t('push_prompt_dismiss')"
          :disabled="activating"
          @click="$emit('dismiss')"
        />
      </div>
      <p class="push-prompt-hint">
        {{ $t("push_prompt_hint") }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    activating: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["activate", "dismiss"],
  data() {
    return {
      titleId: `push-prompt-title-${Math.random().toString(36).slice(2, 9)}`,
    };
  },
};
</script>

<style scoped>
.push-prompt-overlay {
  position: fixed;
  inset: 0;
  background: rgba(12, 35, 63, 0.55);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1100;
  padding: 16px;
}

.push-prompt {
  background: #fff;
  border: 1px solid #dadada;
  border-radius: 12px;
  padding: 24px 20px 18px;
  max-width: 360px;
  width: 100%;
  text-align: center;
  box-shadow: 0 12px 40px rgba(12, 35, 63, 0.18);
}

.push-prompt-icon {
  font-size: 28px;
  margin-bottom: 8px;
  color: #401f4e;
}

.push-prompt-title {
  margin: 0 0 8px;
  color: #0c233f;
  font-size: 18px;
  font-weight: 700;
}

.push-prompt-msg {
  margin: 0 0 18px;
  color: #5c6b7a;
  font-size: 14px;
  line-height: 1.5;
}

.push-prompt-actions {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.push-prompt-actions :deep(.p-button) {
  justify-content: center;
}

.push-prompt-hint {
  margin: 14px 0 0;
  color: #8a96a3;
  font-size: 12px;
}
</style>
